import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from '../../../../styles/media'

const S = {}

S.Image = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  padding-inline: var(--arrow-offset);

  > * {
    margin-left: auto;
    margin-right: auto;

    ${({ ratio }) =>
      ratio === '16x9' &&
      css`
        width: 100%;
        max-width: 54.375rem;
        max-height: 30.75rem;
        transform: translateY(-1.25rem);

        ${media.sm`
          transform: translateY(-0.625rem);
        `};

        ${media.md`
          transform: translateY(0);
        `};
      `};

    ${({ ratio }) =>
      ratio === '2x3' &&
      css`
        width: 18.6875rem;
        aspect-ratio: 2 / 3;
        transform: translateY(-1.1875rem);

        ${media.sm`
          width: 26.625rem;
          transform: translateY(-0.625rem);
        `};

        ${media.md`
          width: 22.625rem;
        `};
      `};
  }
`

export default S
